import React from 'react';
import FormInput from './FormInput';

const ParentInfoForm = ({ 
  formData, 
  setFormData, 
  errors, 
  suggestedParents, 
  showParentSuggestions, 
  searchParents, 
  handleParentSelect 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="relative">
        <FormInput
          label="Nom du parent/tuteur"
          name="nom_parent"
          value={formData.nom_parent}
          onChange={(e) => {
            const { value } = e.target;
            setFormData(prev => ({ ...prev, nom_parent: value }));
            searchParents(value);
          }}
          required
          error={errors.nom_parent}
        />
        
        {showParentSuggestions && suggestedParents.length > 0 && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
            {suggestedParents.map((parent) => (
              <div
                key={parent.id}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex flex-col"
                onClick={() => handleParentSelect(parent)}
              >
                <span className="font-medium">
                  {parent.nom_parent} {parent.prenom_parent}
                </span>
                <span className="text-sm text-gray-600">
                  {parent.contact_parent}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      <FormInput
        label="Prénom du parent/tuteur"
        name="prenom_parent"
        value={formData.prenom_parent}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        error={errors.prenom_parent}
      />
      <FormInput
        label="Contact du parent/tuteur"
        name="contact_parent"
        value={formData.contact_parent}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        error={errors.contact_parent}
      />
      <FormInput
        label="Email du parent/tuteur"
        name="email_parent"
        value={formData.email_parent}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        type="email"
      />
      <FormInput
        label="Adresse du parent/tuteur"
        name="adresse_parent"
        value={formData.adresse_parent}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        className="md:col-span-2"
        error={errors.adresse_parent}
      />
    </div>
  );
};

export default ParentInfoForm;
